import React, { useEffect, useState } from 'react';
import { Loader2, Save, Armchair } from 'lucide-react';
import { adminFetch } from './AdminGate';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SeatManager() {
  const [seats, setSeats] = useState('');
  const [month, setMonth] = useState('');
  const [capacity, setCapacity] = useState(8);
  const [status, setStatus] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetch(`${API}/foundations/seats`).then((r) => r.json()).then((d) => {
      setSeats(String(d.open_seats)); setMonth(d.next_start_month); setCapacity(d.capacity);
    });
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true); setStatus('');
    const r = await adminFetch('/admin/foundations/seats', {
      method: 'PUT',
      body: JSON.stringify({ open_seats: Number(seats), next_start_month: month }),
    });
    setSaving(false);
    setStatus(r.ok ? 'Saved — live on the Programs page.' : 'Save failed. Check values (0–8 seats).');
  };

  return (
    <section className="rounded-2xl bg-white border border-splash-sand p-4 mb-6" data-testid="admin-seat-manager">
      <h2 className="font-display font-bold text-lg text-splash-green mb-1 flex items-center gap-2"><Armchair className="w-4 h-4" /> Foundations seat manager</h2>
      <p className="text-xs text-splash-green/60 mb-3">Update monthly. Capacity is {capacity} seats.</p>
      <form onSubmit={save} className="flex flex-col sm:flex-row gap-3 sm:items-end">
        <label className="text-xs font-semibold text-splash-green/70">Open seats
          <input type="number" min="0" max={capacity} required value={seats} onChange={(e) => setSeats(e.target.value)} data-testid="seat-manager-open-seats" className="mt-1 block w-full sm:w-28 rounded-xl border border-splash-sand px-3 py-2 text-sm" />
        </label>
        <label className="text-xs font-semibold text-splash-green/70 flex-1">Next start month
          <input type="text" required value={month} onChange={(e) => setMonth(e.target.value)} placeholder="e.g. January 2027" data-testid="seat-manager-next-month" className="mt-1 block w-full rounded-xl border border-splash-sand px-3 py-2 text-sm" />
        </label>
        <button type="submit" disabled={saving} data-testid="seat-manager-save" className="inline-flex items-center justify-center gap-2 rounded-full bg-splash-teal hover:bg-splash-tealDark disabled:opacity-60 text-white px-5 py-2.5 text-sm font-semibold btn-transition">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Save
        </button>
      </form>
      {status && <div className="text-xs text-splash-green/70 mt-2" data-testid="seat-manager-status">{status}</div>}
    </section>
  );
}
